/** @format */

import React from 'react';
import ReactDOM from 'react-dom';
// import Router from './router';
import { ConfigProvider } from 'antd';
// import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import TRANSLATION_AR from './_translations/AR/global.json';
import TRANSLATION_CL from './_translations/CL/global.json';
import TRANSLATION_MX from './_translations/MX/global.json';
import TRANSLATION_CLNARMA from './_translations/CLNARMA/global.json';
import TRANSLATION_CLANICX from './_translations/CLANICX/global.json';
import TRANSLATION_CLGREEN from './_translations/CLGREEN/global.json';
import TRANSLATION_CLZUPHARMA from './_translations/CLZUPHARMA/global.json';

import TagManager from 'react-gtm-module';
import { Enviroment } from './_config/constants/enviroment-v2.constant';
import App from './app';

const tagManagerArgs = { gtmId: 'GTM-53L8DCQ' };
TagManager.initialize(tagManagerArgs);

i18next.init({
	lng: Enviroment.LANGUAGE,
	debug: true,
	resources: {
		AR: {
			global: TRANSLATION_AR,
		},
		CL: {
			global: TRANSLATION_CL,
		},
		CLNARMA: {
			global: TRANSLATION_CLNARMA,
		},
		MX: {
			global: TRANSLATION_MX,
		},
		CLANICX: {
			global: TRANSLATION_CLANICX,
		},
		CLGREEN: {
			global: TRANSLATION_CLGREEN,
		},
		CLZUPHARMA: {
			global: TRANSLATION_CLZUPHARMA,
		},
	},
});
if (Enviroment.ENVIRONMENT === 'production') console.log = function () {};

ReactDOM.render(
	<ConfigProvider theme={{ hashed: false }}>
		<App />
		{/* <I18nextProvider i18n={i18next}>
	<Router />
		</I18nextProvider>  */}
	</ConfigProvider>,
	document.getElementById('root'),
);
